import { render, staticRenderFns } from "./client-insights.vue?vue&type=template&id=6c119c80"
import script from "./client-insights.vue?vue&type=script&lang=js"
export * from "./client-insights.vue?vue&type=script&lang=js"
import style0 from "./client-insights.vue?vue&type=style&index=0&id=6c119c80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports